// extracted by mini-css-extract-plugin
export var root = "FavoriteCard-module--root--rPzoc";
export var metaContainer = "FavoriteCard-module--metaContainer--ykVPM";
export var imageContainer = "FavoriteCard-module--imageContainer--qWWOk";
export var actionContainer = "FavoriteCard-module--actionContainer--1xD5B";